/*
Copyright 2023 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Table as SpTable } from '.';
import { TableBody as SpTableBody } from '.';
import { TableCell as SpTableCell } from '.';
import { TableCheckboxCell as SpTableCheckboxCell } from '.';
import { TableHead as SpTableHead } from '.';
import { TableHeadCell as SpTableHeadCell } from '.';
import { TableRow as SpTableRow } from '.';

export const Table = dynamic<
    JSX.LibraryManagedAttributes<typeof SpTable, ComponentProps<typeof SpTable>>
>(() => import('.').then(({ Table }) => Table), { ssr: false });
export const TableBody = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableBody,
        ComponentProps<typeof SpTableBody>
    >
>(() => import('.').then(({ TableBody }) => TableBody), { ssr: false });
export const TableCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCell,
        ComponentProps<typeof SpTableCell>
    >
>(() => import('.').then(({ TableCell }) => TableCell), { ssr: false });
export const TableCheckboxCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableCheckboxCell,
        ComponentProps<typeof SpTableCheckboxCell>
    >
>(() => import('.').then(({ TableCheckboxCell }) => TableCheckboxCell), {
    ssr: false,
});
export const TableHead = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHead,
        ComponentProps<typeof SpTableHead>
    >
>(() => import('.').then(({ TableHead }) => TableHead), { ssr: false });
export const TableHeadCell = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableHeadCell,
        ComponentProps<typeof SpTableHeadCell>
    >
>(() => import('.').then(({ TableHeadCell }) => TableHeadCell), { ssr: false });
export const TableRow = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpTableRow,
        ComponentProps<typeof SpTableRow>
    >
>(() => import('.').then(({ TableRow }) => TableRow), { ssr: false });
